export const VEHICLETYPECODE = {
  DRONE: 'DRONE',
  TRACTOR: 'TRACTOR',
};